import React from "react";

import { resourcesSecondaryModule } from "../../constants";
import * as S from "./styled";

const ResourcesSecondaryModule = () => (
  <S.Container>
    {resourcesSecondaryModule.map(item => (
      <S.Card key={item.href}>
        <S.Link href={item.href}>{item.text}</S.Link>
        <S.Icon>
          <img alt="" src={item.icon} />
        </S.Icon>
        <S.Text>{item.text}</S.Text>
      </S.Card>
    ))}
  </S.Container>
);

export default ResourcesSecondaryModule;
